import { render, staticRenderFns } from "./IntelligenceSuccessionPlanning.vue?vue&type=template&id=23a4ac8a&scoped=true"
import script from "./IntelligenceSuccessionPlanning.vue?vue&type=script&lang=js"
export * from "./IntelligenceSuccessionPlanning.vue?vue&type=script&lang=js"
import style0 from "./IntelligenceSuccessionPlanning.vue?vue&type=style&index=0&id=23a4ac8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a4ac8a",
  null
  
)

export default component.exports